import React from "react";
import { Flex, Text, Tabs, Tab } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { Section, CustomField } from "../../types";
import SectionDisplay from "../SectionDisplay";

export type TabWithSections = {
  tabName: string;
  sections: Array<{
    section: Section;
    fields: CustomField[];
  }>;
};

export type TabsViewProps = {
  tabsWithSections: TabWithSections[];
  activeTab: string;
  onTabChange: (tabName: string) => void;
  onEditField: (field: CustomField) => void;
  onDeleteField: (field: CustomField) => void;
};

export const TabsView: React.FC<TabsViewProps> = ({
  tabsWithSections,
  activeTab,
  onTabChange,
  onEditField,
  onDeleteField,
}) => {
  const activeTabData = tabsWithSections.find(({ tabName }) => tabName === activeTab);

  return (
    <>
      <Tabs style={{ marginBottom: Sizes.LG }}>
        {tabsWithSections.map(({ tabName }) => (
          <Tab
            key={tabName}
            active={activeTab === tabName}
            text={tabName}
            onClick={() => onTabChange(tabName)}
          />
        ))}
      </Tabs>

      {/* Render sections for the active tab */}
      {activeTabData?.sections.map(({ section, fields }) => (
        <SectionDisplay
          key={section.id}
          section={section}
          fields={fields}
          onEditField={onEditField}
          onDeleteField={onDeleteField}
        />
      ))}

      {/* Show empty state if active tab has no sections */}
      {activeTabData?.sections.length === 0 && (
        <Flex flexDirection="column" alignItems="center" style={{ padding: Sizes.LG }}>
          <Text variant="regular-md">No sections in this tab yet.</Text>
        </Flex>
      )}
    </>
  );
};
